/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PidSimulationResponse
 */
export interface PidSimulationResponse {
    /**
     * 
     * @type {string}
     * @memberof PidSimulationResponse
     */
    xmlRequest?: string;
    /**
     * 
     * @type {string}
     * @memberof PidSimulationResponse
     */
    gpCode?: string;
}

/**
 * Check if a given object implements the PidSimulationResponse interface.
 */
export function instanceOfPidSimulationResponse(value: object): value is PidSimulationResponse {
    return true;
}

export function PidSimulationResponseFromJSON(json: any): PidSimulationResponse {
    return PidSimulationResponseFromJSONTyped(json, false);
}

export function PidSimulationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PidSimulationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'xmlRequest': json['xmlRequest'] == null ? undefined : json['xmlRequest'],
        'gpCode': json['gpCode'] == null ? undefined : json['gpCode'],
    };
}

export function PidSimulationResponseToJSON(json: any): PidSimulationResponse {
    return PidSimulationResponseToJSONTyped(json, false);
}

export function PidSimulationResponseToJSONTyped(value?: PidSimulationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'xmlRequest': value['xmlRequest'],
        'gpCode': value['gpCode'],
    };
}

